const UserIdLoginIcon = (color: any) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 48 48"
      fill="none"
    >
      <path
        d="M13.6937 37.0615H13.3832C12.6377 37.0615 12.0332 37.6617 12.0332 38.4018C12.0332 39.142 12.6377 39.7421 13.3832 39.7421H13.6937C14.4392 39.7421 15.0437 39.142 15.0437 38.4018C15.0437 37.6617 14.4392 37.0615 13.6937 37.0615Z"
        fill={color.color}
      />
      <path
        d="M20.6673 37.0615H20.3568C19.6113 37.0615 19.0068 37.6617 19.0068 38.4018C19.0068 39.142 19.6113 39.7421 20.3568 39.7421H20.6673C21.4128 39.7421 22.0173 39.142 22.0173 38.4018C22.0173 37.6617 21.4128 37.0615 20.6673 37.0615Z"
        fill={color.color}
      />
      <path
        d="M27.6419 37.0615H27.3314C26.5859 37.0615 25.9814 37.6617 25.9814 38.4018C25.9814 39.142 26.5859 39.7421 27.3314 39.7421H27.6419C28.3874 39.7421 28.9919 39.142 28.9919 38.4018C28.9919 37.6617 28.3874 37.0615 27.6419 37.0615Z"
        fill={color.color}
      />
      <path
        d="M34.6175 37.0615H34.307C33.5615 37.0615 32.957 37.6617 32.957 38.4018C32.957 39.142 33.5615 39.7421 34.307 39.7421H34.6175C35.363 39.7421 35.9675 39.142 35.9675 38.4018C35.9675 37.6617 35.363 37.0615 34.6175 37.0615Z"
        fill={color.color}
      />
      <path
        d="M38.3284 30.7861H9.67243C5.44393 30.7861 2.00293 34.2024 2.00293 38.4005C2.00293 42.5985 5.44243 46.0163 9.67243 46.0163H38.3284C42.5569 46.0163 45.9979 42.6 45.9979 38.4019C45.9979 34.2039 42.5584 30.7861 38.3284 30.7861ZM38.3284 43.3357H9.67243C6.93193 43.3357 4.70293 41.1227 4.70293 38.4019C4.70293 35.6812 6.93193 33.4682 9.67243 33.4682H38.3284C41.0689 33.4682 43.2979 35.6812 43.2979 38.4019C43.2979 41.1227 41.0689 43.3357 38.3284 43.3357Z"
        fill={color.color}
      />
      <path
        d="M18.7099 21.0893C19.3459 21.4765 20.1769 21.2785 20.5669 20.6485C20.9869 19.9695 22.2409 19.2383 24.0004 19.2383C25.7599 19.2383 27.0139 19.9695 27.4339 20.6485C27.6889 21.0596 28.1314 21.2874 28.5859 21.2874C28.8274 21.2874 29.0704 21.2234 29.2909 21.0893C29.9254 20.7022 30.1249 19.8771 29.7349 19.2457C29.3209 18.5771 28.6909 18.0126 27.9304 17.5703C28.8799 16.5934 29.4709 15.2695 29.4709 13.8071C29.4709 10.8123 27.0169 8.37598 24.0004 8.37598C20.9839 8.37598 18.5299 10.8123 18.5299 13.8071C18.5299 15.2695 19.1209 16.5919 20.0704 17.5703C19.3099 18.0126 18.6799 18.5771 18.2659 19.2457C17.8759 19.8756 18.0754 20.7007 18.7099 21.0893ZM21.2299 13.8056C21.2299 12.2881 22.4734 11.0551 24.0004 11.0551C25.5274 11.0551 26.7709 12.2896 26.7709 13.8056C26.7709 15.3216 25.5289 16.5577 24.0004 16.5577C22.4719 16.5577 21.2299 15.3231 21.2299 13.8056Z"
        fill={color.color}
      />
      <path
        d="M24.0004 28.025C31.3279 28.025 37.2889 22.1069 37.2889 14.8321C37.2889 7.5573 31.3279 1.6377 24.0004 1.6377C16.6729 1.6377 10.7119 7.55581 10.7119 14.8306C10.7119 22.1054 16.6729 28.025 24.0004 28.025ZM24.0004 4.31827C29.8399 4.31827 34.5904 9.03459 34.5904 14.8321C34.5904 20.6296 29.8399 25.3459 24.0004 25.3459C18.1609 25.3459 13.4104 20.6296 13.4104 14.8321C13.4104 9.03459 18.1609 4.31827 24.0004 4.31827Z"
        fill={color.color}
      />
    </svg>
  );
};
export default UserIdLoginIcon;
